import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import variables from "./variables.js";
import Media from "./Media.js";
const Desktop = props => /*#__PURE__*/React.createElement(Media, _extends({
  query: `(${variables.inDesktop})`
}, props));
export default Desktop;